import type { PublicApiKey } from '#packages/apilib';
import type { createClassicSectionResizeAndPushApi } from './classicSectionResizeAndPush';

export const ClassicSectionResizeAndPushApiKey: PublicApiKey<
  typeof createClassicSectionResizeAndPushApi
> = {
  name: 'ClassicSectionResizeAndPushApiKey',
  public: true,
};
